module.exports = __webpack_public_path__ + "img/guangshanyundongRight.9efdabd9.gif";